import { createRouteTranslationModulePreloader } from "@/shared/culture/routeTranslationPreload";
import { DEFAULT_LOCALE } from "@/shared/culture/locales";
import { ensureModuleLoadedWithSharedState } from "@/shared/culture/moduleTranslationLoadState";
import { loadModuleTranslations } from "@/shared/culture/translationLoader";
import { appI18n, appI18nInitialization } from "./i18n";
import type { TranslationModule } from "./translationModules.generated";

export const ensureRouteTranslationModuleLoaded = createRouteTranslationModulePreloader<TranslationModule>({
  i18n: appI18n,
  i18nInitialization: appI18nInitialization,
  defaultLocale: DEFAULT_LOCALE,
  loadModuleTranslations,
  ensureModuleLoaded: ensureModuleLoadedWithSharedState,
});
